export const DATE_TIME_FORMAT = {
  fullDateTime: 'E, MMM dd • h:mma',
  fullDate: 'd MMM yyyy',
  monthYear: 'MMMM yyyy',
  time: 'h:mma',
}
